import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { Subject } from 'rxjs';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { CommercialEntityStructure, ICommercialStructureData } from 'src/app/domain/interfaces/commercial-structure.interface';
import { ISelectProposal } from 'src/app/domain/interfaces/proposal.interface';
import { ISelect } from 'src/app/domain/interfaces/select.interface';
import { BrokerService } from 'src/app/domain/services/broker.service';
import { CommercialStructureService } from 'src/app/domain/services/commercial-structure.service';
import { LiberacaoPropostaTomadorService } from 'src/app/domain/services/parametros/liberacao-proposta-tomador/liberacao-proposta-tomador.service';
import { ProposalService } from "src/app/domain/services/proposals.service";
import { UserService } from 'src/app/domain/services/user.service';
import { AlertTooltipComponent } from '../alert-tooltip/alert-tooltip.component';
import { DialogComponent } from '../dialog/dialog.component';


interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
}

interface FoodNode {
  name: string;
  entity?: string;
  children?: FoodNode[];
}

@Component({
  selector: 'app-dialog-dynamic',
  templateUrl: './dialog-dynamic.component.html'
})


export class DialogDynamicComponent {

  @ViewChild("Tooltip") tooltip: AlertTooltipComponent;

  eventsSubject: Subject<ISelectProposal> = new Subject<ISelectProposal>();
  title: string;
  typeHtml: string;
  productId: number;
  listForm = new UntypedFormControl('', [Validators.required]);
  list: ISelect[] = [];
  tiposPropostaSetorPrivado: ISelect[] = [];
  listBrokers = []
  result= [];
  broker = null;
  brokerselected;
  commercialStructuredId = null;
  commercialStructureSelected = new UntypedFormControl();
  viewValue = null;
  structureCommericalList: ISelect[] = [];
  radioProposalsTypeCtrl = new UntypedFormControl('');
  @Input() firstNameButton: string;
  @Input() secondNameButton: string;
  @Output() eventFirstButton = new EventEmitter<any>(true);
  @Output() eventSecondButton = new EventEmitter<any>(true);
  @Output() eventSecondButtonn = new EventEmitter<any>(true);
  brokerFormControl = new UntypedFormControl();
  optionsBroker = [];
  user: number;
  filteredOptions: Observable<string[]>;
  commercialStructure = [];
  orderCommercialStructureData: ICommercialStructureData[] = [];
  listLinkEntity: ISelect[] = [{ value: '', viewValue: 'Selecione' }];
  requestEntityStructure: CommercialEntityStructure[] = [];
  foodNode: FoodNode;
  showTooltip = false;
  messageTooltip: string;
  locationTooltip: number;
  treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable);
  private transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level,
    };
  }
  treeFlattener = new MatTreeFlattener(this.transformer, node => node.level, node => node.expandable, node => node.children);
  listFoodNode: FoodNode[] = [];

  tipoPropostaSelecionado: ISelectProposal;

  returnEntityName(value: string): string {
    switch (value) {
      case '1': { return 'Seguradora'; }
      case '2': { return 'Diretor'; }
      case '3': { return 'Gerente Comercial'; }
      case '4': { return 'Advogado'; }
      case '5': { return 'Comissionado'; }
      case '6': { return 'Corretora'; }
      case '7': { return 'Tomador'; }
      case '10': { return 'Vendedor'; }
      case '18': { return 'API'; }
      default: {
        break;
      }
    }
  }


  private commercialEntityStructure: CommercialEntityStructure;
  dataSourceTree = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  constructor(
    private commercialStructureService: CommercialStructureService,
    private propososalService: ProposalService,
    private brokerService: BrokerService,
    private userService: UserService,
    private dialogRef: MatDialogRef<DialogDynamicComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private liberacaoDePropostaService: LiberacaoPropostaTomadorService,) {
    this.title = data.title;
    this.typeHtml = data.typeHtml;
    this.list = data.list;
    this.tiposPropostaSetorPrivado = data.tiposPropostaSetorPrivado;
    this.result = data.result;
    this.productId = data.productId;
    this.radioProposalsTypeCtrl.setValue('1');

    if (this.typeHtml === "proposalsCommercialStructure") {
      this.filteredOptions = this.brokerFormControl.valueChanges.pipe(startWith(''), map(value => this.filterBroker(value)));
      this.loadStructure(this.data.idEstruturaComercial);
      this.getAllbroker();
      this.propososalService
        .getCommercialStructure(this.productId)
        .subscribe((res) => {
          res.data.forEach((element) => {
            if (element.name === data.structureCommericalSelected) {
              this.commercialStructureSelected.setValue(element.id);
            }
            this.structureCommericalList.push({
              value: element.id,
              viewValue: element.name,
            });
          });

        });
    }
  }

  ngOnInit(){
    this.userService.getLoggedUser()
    .subscribe(res => {
        this.user = res.data.userType.id;
    });
  }

  showAlertTooltip(){
    this.showTooltip = true;
    this.messageTooltip = "A corretora informada não está vinculada a sua Assessoria!";
    this.locationTooltip = 70;
    this.tooltip.hideTooltip();
  }

  changeDisplayTooltip(event){
    this.showTooltip = event;
  }

  loadStructure(id){
    this.requestEntityStructure = [];
    this.result = [];
    this.commercialStructureService.proposalGetCommercialStructureById(id)
        .subscribe(res => {
          var response = res.data;

          response.commercialEntityStructure = this.orderEntityStructure(response.commercialEntityStructure);
          response.commercialEntityStructure.forEach((e, index) => {
            this.result.push({'viewValue':e.commercialEntityName, 'cpfOrCnpj': e.cpfOrCnpj.replace(/[^\d]+/g,"")});
            this.commercialEntityStructure = {
              id: index + 1,
              name: e.name,
              cpfOrCnpj: e.cpfOrCnpj,
              isRequired: e.isRequired,
              isCommissioning: e.isCommissioning,
              commercialLinkEntityId: e.commercialLinkEntityId,
              commercialLinkEntityName: e.commercialLinkEntityName,
              commercialEntityId: e.commercialEntityId,
              commercialEntityName: e.commercialEntityName,
              nodeLevel: 0,
              hasUpdateOrInsert: false
            };
            this.requestEntityStructure.push(this.commercialEntityStructure);
          });

          this.redrawData(this.requestEntityStructure);

        });

  }

  orderEntityStructure(structure: CommercialEntityStructure[]): CommercialEntityStructure[] {
    const commercialEntityStructureList: CommercialEntityStructure[] = [];

    // Seguradora
    if (structure.filter(x => x.commercialEntityId === '1').length) {
      structure.filter(x => x.commercialEntityId === '1').forEach(item => {
        commercialEntityStructureList.push(item);
      });
    }
    // Diretor
    if (structure.filter(x => x.commercialEntityId === '2').length) {
      structure.filter(x => x.commercialEntityId === '2').forEach(item => {
        commercialEntityStructureList.push(item);
      });
    }
    // Gerente Comercial
    if (structure.filter(x => x.commercialEntityId === '3').length) {
      structure.filter(x => x.commercialEntityId === '3').forEach(item => {
        commercialEntityStructureList.push(item);
      });
    }
    // Corretora
    if (structure.filter(x => x.commercialEntityId === '6' || x.commercialEntityId === '18').length) {
      structure.filter(x => x.commercialEntityId === '6' || x.commercialEntityId === '18').forEach(item => {
        commercialEntityStructureList.push(item);
      });
    }

    // Comissionado
    if (structure.filter(x => x.commercialEntityId === '5').length) {
      structure.filter(x => x.commercialEntityId === '5').forEach(item => {
        commercialEntityStructureList.push(item);
      });
    }

    return commercialEntityStructureList;
  }


  close(): void {
    this.dialogRef.close();
  }

  actionFirstButton(): void {
    this.eventFirstButton.emit();
    this.dialogRef.close();
  }

  async actionSecondButton(event): Promise<void> {

    if (this.typeHtml === 'proposals') {
      await this.liberacaoDePropostaService.getParametroTomadorByTomadorAndProposta(0, Number.parseInt(this.tipoPropostaSelecionado.value), 0).pipe().toPromise().then(async res => {
        if (res.success === false) {
          const dialogRef = this.dialog.open(DialogComponent, {
            data: {
              title: "Atenção",
              text: res.message,
            },
            height: "238px",
            width: "480px",
            disableClose: true,
          });
          dialogRef.componentInstance.secondNameButton = "ENTENDI";
          dialogRef.componentInstance.eventSecondButton.subscribe((res) => {
          });
          return;
        } else {
          this.eventSecondButton.emit({ listType: this.listForm.value, "value": event });
          this.eventsSubject.next(this.tipoPropostaSelecionado);
          this.dialogRef.close();
        }
      });
    } else {
      this.eventSecondButton.emit({ listType: this.listForm.value, "value": event });
      this.eventsSubject.next(this.tipoPropostaSelecionado);
      this.dialogRef.close();
    }

  }

  radioProposalsTypeSelected(): void {

  }

  selectcommercialStructure(item) {
    this.brokerFormControl.setErrors({ insuredError: false });
    this.brokerFormControl.setValue('');
    this.broker = null;
    this.brokerselected = undefined;
    this.loadStructure(item);
    this.commercialStructuredId = item;
  }


  redrawData(result: CommercialEntityStructure[]): void {
    this.listFoodNode = [];
    this.listLinkEntity = [];
    this.orderCommercialStructureData = [];
    this.treeFlattener = new MatTreeFlattener(this.transformer, node => node.level, node => node.expandable, node => node.children);
    this.treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable);
    this.dataSourceTree = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    // ORDENAR
    result.sort((a, b) => {
      if (a.id > b.id) {
        return 1;
      } else if (a.id < b.id) {
        return -1;
      } else {
        return 0;
      }
    });

    result.forEach((item) => {
      const entityName = this.returnEntityName(item.commercialEntityId);
      const joinName = `${entityName}: ${item.name}`;

      // ADD LINK ENTITY
      this.listLinkEntity.push({
        value: item.commercialEntityId,
        viewValue: joinName
      });


     // DATA TREE
     if (item.commercialLinkEntityId === '' || item.commercialLinkEntityId === null || item.commercialLinkEntityId === '0') {
      this.foodNode = { name: joinName, entity: item.commercialEntityId };
      this.listFoodNode.push(this.foodNode);
     }
     else if(item.commercialLinkEntityId === '1' && this.listFoodNode.length === 0)
     {
      this.foodNode = { name: joinName, entity: item.commercialEntityId };
      this.listFoodNode.push(this.foodNode);
     }
     else
     {
        let name: string;

        if (item.commercialEntityId === '2') {
          name = this.listLinkEntity.find(x => x.value === item.commercialLinkEntityId).viewValue;
        } else if(!!item.commercialLinkEntityName) {
          if(!!this.listLinkEntity.find(x => x.viewValue.toUpperCase() === item.commercialLinkEntityName.toUpperCase())){
            name = this.listLinkEntity.find(x => x.viewValue.toUpperCase() === item.commercialLinkEntityName.toUpperCase()).viewValue;
          } else {
            name = this.listLinkEntity.find(x => x.viewValue.toUpperCase() === item.commercialEntityName.toUpperCase()).viewValue;
          }
        } else {
          name = this.listLinkEntity.find(x => x.viewValue.toUpperCase() === item.commercialEntityName.toUpperCase()).viewValue;
        }

        this.addNodeChildren(this.listFoodNode, item.commercialEntityId, item.name, name);
      }
    });

    // ADD TREE
    this.dataSourceTree.data = this.listFoodNode;
  }
  addNodeChildren(list: FoodNode[], entity: string, name: string, linkEntityId: string): void {
    let listfoodNodeChildren: FoodNode[] = [];
    let foodNodeChildren: FoodNode;
    const entityName = this.returnEntityName(entity);
    const joinName = `${entityName}: ${name}`;
    list.forEach(item => {
      if (item.name === linkEntityId) {
        foodNodeChildren = { name: joinName, entity };
        listfoodNodeChildren = item.children === undefined ? [] : item.children;
        listfoodNodeChildren.push(foodNodeChildren);
        item.children = listfoodNodeChildren;
      } else {
        if (item.children !== undefined) {
          this.addNodeChildren(item.children, entity, name, linkEntityId);
        }
      }
    });
  }

  selectOptionBroker(event: MatAutocompleteSelectedEvent) {
    this.broker = {nmPessoa: event.option.value, cnpjCpf: event.option.id}
    this.brokerFormControl.setValue(this.broker.nmPessoa);
    this.brokerselected = undefined;
    const estruturasAssessoria = [];
    let isValid = false;

    if(this.user !== 8){
      for (var i = 0; i < this.result.length; i++) {
        if (this.result[i].cpfOrCnpj.includes(this.broker.cnpjCpf)) {
          this.viewValue = this.result[i].viewValue;
          this.brokerselected = this.result[i];
          break;
        }
      }

      if (this.brokerselected == undefined) {
        this.brokerFormControl.setErrors({ insuredError: true });
        this.showModal(
          'Atenção!',
          'A Corretora informada não pertence a esta Estrutura Comercial escolhida! Selecione uma nova Corretora ou altere a Estrutura Comercial',
          null, 'ENTENDI');
          return;
      }else {
        this.brokerFormControl.setErrors({ insuredError: false });
      }
    }

    if(this.user === 8){
      this.requestEntityStructure.forEach(e =>{
        estruturasAssessoria.push({
          name: e.name,
        });
      });

      estruturasAssessoria.forEach(ea =>{
        if(this.broker.nmPessoa.toLowerCase() === ea.name.toLowerCase()){
          isValid = true;
          return;
        };
      });

      if(!isValid){
        this.showAlertTooltip();
        this.brokerFormControl.setErrors({ insuredError: false });
        return;
      }
    }
  }

  selectButtonOptionBroker(event: MatAutocompleteSelectedEvent) {
    this.brokerselected = undefined;
    for (var i = 0; i < this.result.length; i++) {
      if (this.result[i].cpfOrCnpj.includes(this.broker.cnpjCpf)) {
        this.viewValue = this.result[i].viewValue;
        this.brokerselected = this.result[i];
        break;
      }
    }

    if (this.brokerselected != undefined) {
      this.eventSecondButtonn.emit({ listType: this.brokerselected, "commercialStructureId": this.commercialStructuredId || this.commercialStructureSelected.value });
      this.dialogRef.close();
    }else {
      this.showModal(
        'Atenção!',
        'Nenhuma corretora pertencente a estrutura comercial foi selecionada.',
        null, 'ENTENDI');
    }
  }


  getAllbroker() {
    this.brokerService
      .getAll()
      .subscribe((res) => {
        this.optionsBroker = [];
        res.data.value.forEach(e => {
          this.optionsBroker.push({nmPessoa: e.nmPessoa, cnpjCpf: e.nrCnpjCpf.replace(/[^\d]+/g,"")});
        });
      })
  }

  destroyComponent(){

  }

  tipoPropostaChange(event){
    if(event != null){
      this.listForm.setValue(event.value);
      this.tipoPropostaSelecionado = event;
    }
    else{
      this.listForm.reset();
      this.tipoPropostaSelecionado = null;
    }
  }
    private filterBroker(value: string): string[] {
      const filterValue = value.toLowerCase();

      return this.optionsBroker.filter(option => option.nmPessoa.toLowerCase().includes(filterValue));
    }

    showModal(title: string, text: string, firstNameButton: string, secondNameButton: string): void {
      const dialogRef =  this.dialog.open(DialogComponent, {
        data: { title, text },
        height: '238px',
        width: '480px'
      });
      dialogRef.componentInstance.secondNameButton = secondNameButton;
    }

}

